import React from 'react';
import langConf from "../js/lang";
import './Login.css';
import BackButton from './BackButton';
import shelegLogin from '../api/shelegLogin';

class ForgotPassword extends React.Component {

    handleEmailPasswordClick = async (event) => { //return to login screen + complete validation and error messages
        event.preventDefault();
        let lang = this.props.lang;
        let send = false;
        let email = document.querySelector('#fpemail').value;
        let mobile = document.querySelector('#fpmobile').value;
        mobile = mobile.replace('-', '');
        email = email.toLowerCase();
        if (mobile === '' && email === '') {
            window.alert(langConf[lang].enterEmailOrMobile);
        }
        else if (email === '') {
            if (this.validatePhone(mobile)) {
                send = true;
            }
        }
        else if (mobile === '') {
            if (this.validateEmail(email)) {
                send = true;
            }
        }
        else if (this.validateEmail(email) && this.validatePhone(mobile)) {
            send = true;
        }
        if (send) {
            let recovery = { email: email, mobile: mobile };
            let response = await shelegLogin.post(`RestorePassword/${localStorage.getItem('sessionId')}`, recovery);
            if (response.statusText === 'OK') {
                window.alert(langConf[lang].emailSent);
                this.props.changePaymentMode('login');
            }
            //console.log(response);
        }
    };

    handleKeyDown = async (e) => {
        //console.log('key: ', e.key);
        if (e.key === 'Enter') {
            if (await this.validateLogin()) {
                this.handleEmailPasswordClick();
            }
        }
    };

    validateEmail(email) {
        //if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            return true;
        }
        return false;
    };

    validatePhone(phone) {
        var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        if ((phone.match(phoneno))) {
            return true;
        }
        else {
            return false;
        }
    };

    render() {
        let lang = this.props.lang;
        let currentURL = this.props.currentURL;
        let isDisabled = false;
        return (
            <div className="col-12 panel panel-info" style={this.props.visible === false ? { display: 'none' } : {}}>
                <div className='panel-heading'>{langConf[lang].forgotPasswordMessage}</div>
                <div className='col-12'>
                    <div className='col-4 col-lg-4 col-md-3 col-xs-0 col-sm-0'></div>
                    <div className='col-4 col-lg-4 col-md-6 col-xs-12 col-sm-12'>
                        <div className="col-12">
                            <div className="col-12">
                                <div className={`ui big input field email ${lang}`}>
                                    <label className={`label email ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].email}</label>
                                    <input id='fpemail' type='email' className={`form-control input-lg ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} style={{ textAlign: 'right' }} onKeyDown={this.handleKeyDown}></input>
                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="col-12">
                                <div className={`ui big input field mobile ${lang}`}>
                                    <label className={`label mobile ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].mobile}</label>
                                    <input id='fpmobile' type='tel' className={`form-control input-lg ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} style={{ textAlign: 'right' }} onKeyDown={this.handleKeyDown}></input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-4 col-lg-4 col-md-3 col-xs-0 col-sm-0'></div>
                </div>

                <div className="col-12">
                    <div className='col-2 col-xs-0 col-sm-0'></div>
                    <div className="col-4 col-xs-6 col-sm-6">
                        <BackButton
                            //Globals
                            lang={lang}
                            currentURL={currentURL}
                            //Methods
                            onClick={(event) => { event.preventDefault(); this.props.changePaymentMode('login') }}
                        />
                    </div>
                    <div className="col-4 col-xs-6 col-sm-6">
                        <a href={currentURL} className={`btn btn-success btn-block btn-lg ${isDisabled} login-button ${lang}`} onClick={this.handleEmailPasswordClick}>{langConf[lang].emailPassword}</a>
                    </div>
                    <div className='col-2 col-xs-0 col-sm-0'></div>
                </div>
            </div>
        );
    }
}

export default ForgotPassword;